export const APIEndpoints = {
  FetchVendorsList: '/v0/service/vendor/list',
};
